import { AxiosRequestConfig, AxiosResponseTransformer } from 'axios';

import { BASE_API } from '../utils';

interface ListConfig extends AxiosRequestConfig {
  baseURL: string;
  method: 'GET';
  url: `/teachers/${string}/classes/${string}/assignments`;
  transformResponse: AxiosResponseTransformer;
}

/**
 * GET /vo/v1/teachers/${teacherId}/classes/${classId}/assignments
 */
export const list = (teacherId: string, classId: string): ListConfig => {
  return {
    baseURL: BASE_API,
    method: 'GET',
    url: `/teachers/${teacherId}/classes/${classId}/assignments`,
    transformResponse: function (data) {
      return { classAssignments: JSON.parse(data) };
    },
  } as const;
};
